var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-title h-18px text-hex-fff flex items-center"},[_c('span',{staticClass:"decoration inline-block w-18px h-18px"}),_c('span',{staticClass:"ml-10px text-14px font-bold"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }